import React from "react";

import { OTSession, OTStreams, preloadScript } from "opentok-react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import classnames from "classnames";
import { toast } from "react-toastify";
import moment from "moment";

import "./index.css";
import constants, { getDashboardPath } from "../../../../constants";
import { REMOVE_VALIDATIONS } from "../../../../store/actions/actionTypes";
import messages from "../../../../constants/messages";
import * as actions from "../../../../store/actions";

import Publisher from "./Publisher";
import Subscriber from "./Subscriber";
import MainNotes from "../InCall";
import AddParticipants from "../InCall/AddParticipants";
import Chat from "../InCall/Chat";
import Header from "../Header";
import { getUserData } from "../../../../utils/localStorage";
import ShowVitals from "../InCall/ShowVitals";
import Prescriptions from "../InCall/Prescriptions";

class StartCall extends React.Component {
  constructor(props) {
    super(props);
    this.otSession = React.createRef();
    this.state = {
      error: null,
      connected: false,
      session: null,
      endCall: false,
      no_user_connected: 0,
      stream_changed: [],
      takeScreenshot: false,
      screenshot: null,
      permission: undefined,
      streams: [],
      appointment_type: this.props.history?.location?.state?.appointment_type,
      users: [],
      signalReceived: false,
      publisherId: undefined,
      not_joining: undefined,
    };

    console.log(this.state)

    this.sessionEvents = {
      streamCreated: event => {
        this.setState(
          {
            no_user_connected: this.state.no_user_connected + 1,
            streams: [...this.state.streams, event.stream],
          },
          () => this.sendUserInfoSignalfromSubscriber(event.stream.connection)
        );

        this.updateLayout();
      },
      streamDestroyed: () => {
        this.setState({
          no_user_connected: this.state.no_user_connected - 1,
        });
        this.updateLayout();
      },
      sessionConnected: event => {
        event.preventDefault();
        this.setState({
          connected: true,
        });
      },
      sessionDisconnected: event => {
        event.preventDefault();
        this.setState({ connected: false });
        this.props.clearControl();

        if (this.props.ongoingAppointment?.visitNow?.is_subscribed_patient || this.props.appointment?.is_subscribed_patient) {
          this.props.history.push({pathname: getDashboardPath("/appointments")});
        } else {
          this.props.history.push({
            pathname: getDashboardPath("/appointments"),
            state: {
              callEnded: !!this.props.ongoingAppointment?.users?.find(user =>
                ["PATIENT", "PARENT"].includes(user.type)
              ),
            },
          });
        }

        this.props.removeOngoingAppointmentData();
        this.otSession.current?.sessionHelper?.session?.off("signal");
      },
      streamPropertyChanged: event => {
        let streamChanged = this.state.stream_changed;
        if (
          event.changedProperty === "hasAudio" &&
          event.stream?.publisher === null
        ) {
          streamChanged = {
            ...streamChanged,
            [event.stream.id]: {
              hasAudio: event.newValue,
            },
          };
          this.setState({
            stream_changed: streamChanged,
          });
        } else if (
          event.changedProperty === "hasVideo" &&
          event.stream?.publisher === null
        ) {
          streamChanged = {
            ...streamChanged,
            [event.stream.id]: {
              hasVideo: event.newValue,
            },
          };
          this.setState({
            stream_changed: streamChanged,
          });
        }
      },
    };
  }

  updateLayout() {
    const eles = document.getElementsByClassName("OTSubscriberContainer");

    Array.from(eles).forEach((element, i) => {
      element.style.width = this.state.no_user_connected > 1 ? "49%" : "100%";
      element.style.height =
        this.state.no_user_connected > 2 ? "50vh" : "100vh";
      element.style.left = i % 2 === 0 ? (i === 2 ? "25%" : 0) : "51%";
      element.style.top = i > 0 && i % 2 === 0 ? "51%" : 0;
      element.style.transition = "all 500ms ease";
    });
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleLeave);
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });

    this.props.setOngoingAppointmentData({
      appointmentType: this.state.appointment_type,
    });

    this.props.clearTemplateData();
    this.props.clearControl();
    this.props.removeValidations();

    this.otSession.current.sessionHelper.session.on(
      "signal:user_info_message",
      event => {
        event.from.connectionId !==
          this.otSession.current.sessionHelper?.session.connection
            .connectionId &&
          this.props.setOngoingAppointmentData({
            users: [
              JSON.parse(event?.data),
              ...this.props.ongoingAppointment?.users,
            ],
          });
      }
    );

    this.otSession.current.sessionHelper.session.on(
      "signal:text_message",
      event => {
        let sender_name = "";

        this.state.streams.forEach(stream => {
          if (event?.from?.connectionId === stream?.connection?.id)
            sender_name = stream?.name;
        });

        this.props.setOngoingAppointmentData({
          chats: [
            {
              participantType:
                event.from.connectionId ===
                this.otSession.current.sessionHelper?.session.connection
                  .connectionId
                  ? "mine"
                  : "theirs",
              data: event.data,
              date: moment().format("ddd MMM HH:mm A"),
              name: sender_name,
            },
            ...(this.props.ongoingAppointment?.chats || []),
          ],

          signalReceived: true,
        });
        this.setState({
          signalReceived: !this.props.control.chat && true,
        });
      }
    );

    this.otSession.current.sessionHelper.session.on(
      "signal:screenshot_permission_message",
      event => {
        event.from.connectionId !==
          this.otSession.current.sessionHelper?.session.connection
            .connectionId &&
          JSON.parse(event?.data)?.status === "REQUESTED" &&
          this.setState({
            permission: {
              type: event.type,
              data: JSON.parse(event?.data),
              id: event?.from?.connectionId,
              from: event?.target?.connection?.id,
            },
          });
      }
    );

    this.otSession.current.sessionHelper.session.on(
      "signal:document_message",
      event => {
        let sender_name = "";

        this.state.streams.forEach(stream => {
          if (event?.from?.connectionId === stream?.connection?.id)
            sender_name = stream?.name;
        });

        this.props.setOngoingAppointmentData({
          chats: [
            {
              participantType:
                event.from.connectionId ===
                this.otSession.current.sessionHelper?.session.connection
                  .connectionId
                  ? "mine"
                  : "theirs",
              data: event.data,
              date: moment().format("ddd MMM HH:mm A"),
              name: sender_name,
              type: "document",
            },
            ...(this.props.ongoingAppointment?.chats || []),
          ],
          signalReceived: true,
        });
        this.setState({
          signalReceived: !this.props.control.chat && true,
        });
      }
    );
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleLeave);
  }

  handleLeave = e => {
    e.preventDefault();
    e.returnValue = "";
  };

  handleNoUserJoing = () => {
    return (
      moment(new Date()).format("HH:mm") ==
      moment(new Date()).add(1, "m").format("HH:mm")
    );
  };

  onError = err => {
    this.setState({ error: `Failed to connect: ${err.message}` });
  };

  onDestroySession = event => {
    localStorage.removeItem("viewMode");
    if (
      Object.keys(this.props.form).length > 0 &&
      this.props.form &&
      !this.props.form.templatesValid
    ) {
      toast.error(messages.NOTE_REQUIRED_FILEDS, {
        position: constants.TOAST_POSITION,
      });
    } else {
      this.props.clearScreenshots();
      this.props.setViewMode();
      this.props.removeValidations();

      if (this.props.ongoingAppointment?.visitNow) {
        this.props.ongoingAppointment?.visitNow?.id &&
          this.props.updateVisitNowRequestStatus(
            this.props.ongoingAppointment?.visitNow?.id
          );
      }

      // added commented code, will remove while implementing the feature

      if (
        this.props?.appointment?.id &&
        // this.state.streams.length > 0 &&
        this.state.appointment_type === "future_appointment"
      ) {
        this.props.updateAppointmentCompletedStatus(
          this.props?.appointment?.id
        );
      }

      if (this.state.connected) {
        if (this.otSession.current.sessionHelper?.session) {
          this.otSession?.current?.sessionHelper?.session?.disconnect();
        }
      } else {
        this.props.history.push(getDashboardPath("/appointments"));
      }
    }

    this.otSession.current.sessionHelper.session.off("signal:text_message");
    this.otSession.current.sessionHelper.session.off(
      "signal:screenshot_permission_message"
    );
    this.otSession.current.sessionHelper.session.off(
      "signal:user_info_message"
    );
    this.otSession.current.sessionHelper.session.off("signal:document_message");
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.control.notes !== nextProps.control.notes ||
      this.props.control.addParticipants !==
        nextProps.control.addParticipants ||
      this.props.control.chat !== nextProps.control.chat ||
      this.props.control.showVitals !== nextProps.control.showVitals ||
      this.props.control.prescriptions !== nextProps.control.prescriptions ||
      this.props.appointments !== nextProps.appointments ||
      this.state !== nextState ||
      this.props.personalInfo !== nextProps.personalInfo
    );
  }

  sendSignal = (msg = "", type = "text_message") => {
    type === "text_message"
      ? this.otSession.current.sessionHelper.session.signal(
          {
            type,
            data: msg,
          },
          function (error) {
            if (error) {
              //adding comments for debugging purpose with other platforms will remove once tested
              console.log("signal error: " + error.message);
            } else {
              console.log("chat sent");
            }
          }
        )
      : this.otSession.current.sessionHelper.session.signal(
          {
            type: type,
            To: this.state.permission?.id,
            data: msg,
          },
          function (error) {
            //adding comments for debugging purpose with other platforms will remove once tested
            if (error) {
              console.log("signal error: " + error);
            } else {
              console.log("signal sent");
            }
          }
        );

    type === "screenshot_permission_message" &&
      this.setState({
        permission: undefined,
      });
  };

  sendDocumentSignal = (msg = "", type = "document_message") => {
    this.otSession.current.sessionHelper.session.signal(
      {
        type,
        data: msg,
      },
      function (error) {
        //adding comments for debugging purpose with other platforms will remove once tested
        if (error) {
          console.log("signal error: " + error.message);
        } else {
          console.log("chat sent");
        }
      }
    );
  };

  sendUserInfoSignal = publisherId => {
    if (publisherId) {
      const appointment =
        (this.state.appointment_type === "future_appointment" &&
          this.props.appointment) ||
        (this.state.appointment_type === "visit_now_appointment" &&
          this.props.ongoingAppointment?.visitNow);

      const id = getUserData()?.id;

      let type = "";

      if (this.state.appointment_type === "future_appointment") {
        if (appointment?.doctor_detail?.id === id) type = "MAIN_PHYSICIAN";
        else if (appointment?.guest_doctor_id === id) type = "GUEST_PHYSICIAN";
      }

      if (this.state.appointment_type === "visit_now_appointment") {
        if (appointment?.doctor?.id === id) type = "MAIN_PHYSICIAN";
        else if (appointment?.guest_doctor?.id === id) type = "GUEST_PHYSICIAN";
      }

      const userObj = {
        streamId: publisherId,
        userId: getUserData()?.id,
        name: getUserData()?.firstName + " " + getUserData()?.lastName,
        image:
          this.props?.personalInfo?.photo?.src || getUserData()?.image?.src,
        type: type,
        id: getUserData()?.user,
      };

      this.state.streams.forEach((stream, i) => {
        this.otSession.current.sessionHelper.session.signal(
          {
            type: "user_info_message",
            to: stream.connection,
            data: JSON.stringify(userObj),
          },
          function (error) {
            //adding comments for debugging purpose with other platforms will remove once tested

            if (error) {
              console.log("signal error: " + error);
            } else {
              console.log("signal sent");
            }
          }
        );
      });
    }
  };

  sendUserInfoSignalfromSubscriber = connectionId => {
    if (this.state.publisherId) {
      const appointment =
        (this.state.appointment_type === "future_appointment" &&
          this.props.appointment) ||
        (this.state.appointment_type === "visit_now_appointment" &&
          this.props.ongoingAppointment?.visitNow);

      const id = getUserData()?.id;

      let type = "";

      if (this.state.appointment_type === "future_appointment") {
        if (appointment?.doctor_detail?.id === id) type = "MAIN_PHYSICIAN";
        else if (appointment?.guest_doctor_id === id) type = "GUEST_PHYSICIAN";
      }

      if (this.state.appointment_type === "visit_now_appointment") {
        if (appointment?.doctor?.id === id) type = "MAIN_PHYSICIAN";
        else if (appointment?.guest_doctor?.id === id) type = "GUEST_PHYSICIAN";
      }

      const userObj = {
        streamId: this.state.publisherId,
        userId: getUserData()?.id,
        name: getUserData()?.firstName + " " + getUserData()?.lastName,
        image:
          this.props?.personalInfo?.photo?.src || getUserData()?.image?.src,
        type: type,
        id: getUserData()?.user,
      };

      this.otSession.current.sessionHelper.session.signal(
        {
          type: "user_info_message",
          to: connectionId,
          data: JSON.stringify(userObj),
        },
        function (error) {
          if (error) {
            console.log("signal error: " + error);
          } else {
            console.log("signal sent");
          }
        }
      );
    }
  };

  render() {
    toast.error(!this.state.error, {
      position: constants.TOAST_POSITION,
    });

    return (
      <>
        {this.props.control?.notes && (
          <aside className="call-notes aside-bar col-md-3 p-0 m-0">
            <Header
              title="Notes"
              onClick={() => {
                this.props.changeControl({
                  notes: !this.props.control?.notes,
                });
                this.props.clearScreenshots();
              }}
              onArrowClick={() => {
                this.props.removeValidations();
                this.props.setViewMode(1);
                this.props.clearTemplateData();
                this.props.clearScreenshots();
              }}
            />
            <div>
              <MainNotes />
            </div>
          </aside>
        )}

        {this.props.control?.addParticipants && (
          <aside className="call-notes aside-bar col-md-3 p-0 m-0">
            <Header
              title="Add to call"
              onClick={() =>
                this.props.changeControl({
                  addParticipants: !this.props.control?.addParticipants,
                })
              }
            />
            <div>
              <AddParticipants
                id={this.props?.appointment?.patient_detail?.id}
                onClose={() =>
                  this.props.changeControl({
                    addParticipants: !this.props.control?.addParticipants,
                  })
                }
              />
            </div>
          </aside>
        )}

        {this.props.control?.chat && (
          <aside className="call-notes aside-bar col-md-3 p-0 m-0">
            <Header
              title="Chat"
              onClick={() =>
                this.props.changeControl({
                  chat: !this.props.control?.chat,
                })
              }
            />
            <div>
              <Chat sendSignal={msg => this.sendSignal(msg)} />
            </div>
          </aside>
        )}

        {this.props.control?.showVitals && (
          <aside className="call-notes aside-bar col-md-3 p-0 m-0">
            <Header
              title="Vitals"
              onClick={() =>
                this.props.changeControl({
                  showVitals: !this.props.control?.showVitals,
                })
              }
            />
            <div>
              <ShowVitals />
            </div>
          </aside>
        )}

        {this.props.control?.prescriptions && (
          <aside className="call-notes aside-bar col-md-3 p-0 m-0">
            <Header
              title="Prescriptions"
              onClick={() =>
                this.props.changeControl({
                  prescriptions: !this.props.control?.prescriptions,
                })
              }
            />
            <div>
              <Prescriptions />
            </div>
          </aside>
        )}

        <div
          className={classnames(
            "call-container",
            this.props.control?.notes ||
              this.props.control?.addParticipants ||
              this.props.control?.chat ||
              this.props.control?.showVitals ||
              this.props.control?.prescriptions
              ? "col-md-9"
              : "col-md-12"
          )}
        >
          {this.state.no_user_connected === 0 && (
            <p className="center-element">
              <span
                class="spinner-grow text-light mr-3 mb-n1"
                role="status"
              ></span>
              <span
                style={{
                  color: "white",
                  fontSize: 20,
                }}
              >
                Waiting for{" "}
                {this.props?.appointment?.patient_detail?.first_name ||
                  this.props?.ongoingAppointment?.visitNow?.patient
                    ?.first_name}{" "}
                {this.props?.appointment?.patient_detail?.last_name ||
                  this.props?.ongoingAppointment?.visitNow?.patient
                    ?.last_name}{" "}
                to join
              </span>
            </p>
          )}
          <OTSession
            apiKey={process.env.REACT_APP_OPENTOK_API_KEY}
            sessionId={localStorage.getItem("opentok_session_id")}
            token={localStorage.getItem("opentok_token")}
            eventHandlers={this.sessionEvents}
            onError={this.onError}
            ref={this.otSession}
          >
            <Publisher
              onDestroy={this.onDestroySession}
              profileImage={this.props?.personalInfo?.photo?.src}
              noOfUsersConnected={this.state.no_user_connected}
              connected={this.state.connected}
              sendPermissionSignal={this.sendSignal}
              sendSignal={this.sendDocumentSignal}
              permission={this.state.permission}
              signalReceived={this.state.signalReceived}
              onSetSignalReceived={() =>
                this.setState({ signalReceived: false })
              }
              setPublisher={id => {
                this.setState({ publisherId: id });
                this.sendUserInfoSignal(id);
              }}
            />
            <OTStreams>
              <Subscriber
                noOfStreams={this.state.no_user_connected}
                stream_changed={this.state.stream_changed}
                profileImage={this.props?.appointment?.patient_detail?.image}
                users={this.props.ongoingAppointment.users}
                streams={this.state.streams}
              />
            </OTStreams>
          </OTSession>
        </div>
      </>
    );
  }
}

const mapStoreToProps = ({ dashboard, onboarding, validation }) => ({
  personalInfo: onboarding.personalInfo,
  appointment: dashboard.appointments?.schAppointmentDetail,
  control: dashboard.appointments?.control,
  form: validation.data,
  ongoingAppointment: dashboard?.ongoingAppointment,
});

const mapDispatchToProps = dispatch => ({
  changeControl: control => dispatch(actions.changeControl(control)),
  clearControl: () => dispatch(actions.clearControl()),
  clearScreenshots: () => dispatch(actions.clearScreenshots()),
  setViewMode: id => dispatch(actions.setViewMode(id)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
  setOngoingAppointmentData: updatedData =>
    dispatch(actions.setOngoingAppointmentData(updatedData)),
  updateVisitNowRequestStatus: visitNowId =>
    dispatch(
      actions.updateVisitNowRequestStatus(
        visitNowId,
        constants.APPOINTMENT_STATUS.completed
      )
    ),

  removeOngoingAppointmentData: () =>
    dispatch(actions.removeOngoingAppointmentData()),
  updateAppointmentCompletedStatus: appointmentId =>
    dispatch(actions.updateAppointmentCompletedStatus(appointmentId)),
});

export default preloadScript(
  withRouter(connect(mapStoreToProps, mapDispatchToProps)(StartCall))
);
